import React from "react";

const ProcessingFeeIcon: React.FC<{ color?: string }> = ({ color = "currentColor" }) => (
  <>
    <path
      d="M2.5 8.33073H17.5M5 15.8307H15C16.3807 15.8307 17.5 14.7114 17.5 13.3307V6.66406C17.5 5.28335 16.3807 4.16406 15 4.16406H5C3.61929 4.16406 2.5 5.28335 2.5 6.66406V13.3307C2.5 14.7114 3.61929 15.8307 5 15.8307Z"
      stroke={color}
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83203 12.5H5.84036M9.16536 12.5H10.832"
      stroke="currentColor"
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);

export default ProcessingFeeIcon;
